/**
 * Promo code accordion toggle (native Shopify discount field).
 */
(function () {
  function onToggleClick(event) {
    const btn = event.currentTarget;
    const id = btn.getAttribute('aria-controls');
    if (!id) return;

    const panel = document.getElementById(id);
    if (!panel) return;

    const expanded = btn.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      btn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('hidden', '');
      panel.classList.remove('open');
    } else {
      btn.setAttribute('aria-expanded', 'true');
      panel.removeAttribute('hidden');
      panel.classList.add('open');
    }
  }

  function init() {
    document.querySelectorAll('.po-discount-toggle').forEach((toggle) => {
      const id = toggle.getAttribute('aria-controls');
      if (!id) return;

      toggle.removeEventListener('click', onToggleClick);
      toggle.addEventListener('click', onToggleClick);
    });

    document.addEventListener('click', onDocumentClick);
  }

  function onDocumentClick(event) {
    if (event.target.closest('.po-discount-toggle')) return;

    document.querySelectorAll('.po-discount-toggle[aria-expanded="true"]').forEach((openToggle) => {
      const ctrl = openToggle.getAttribute('aria-controls');
      const panel = document.getElementById(ctrl);
      if (!panel) return;

      if (!panel.contains(event.target) && !openToggle.contains(event.target)) {
        openToggle.setAttribute('aria-expanded', 'false');
        panel.setAttribute('hidden', '');
        panel.classList.remove('open');
      }
    });
  }

  window.poDiscountDropdownInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
